import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/Home';
import FeaturesPage from './pages/Features';
import PricingPage from './pages/Pricing';
import ConnectorsPage from './pages/Connectors';

// Dashboard app URL for auth links
export const DASHBOARD_URL = 'https://dashboard.nexuserp.app';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="features" element={<FeaturesPage />} />
        <Route path="pricing" element={<PricingPage />} />
        <Route path="connectors" element={<ConnectorsPage />} />
      </Route>
    </Routes>
  );
}
